/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
// import Tooltip from "@mui/material/Tooltip";
// import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
// import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
// import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
// import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
// import BookingCard from "examples/Cards/BookingCard";

import { useEffect, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as service from '../../../services/service';

function Analytics() {
  const [regionCountData, setRegionCountData] = useState([]);
  
  const getRegionWiseCounts = () => {
    fetch(
      service.GET_REGION_WISE_DASHBOARD,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
        },
        body: JSON.stringify({
          UserRole: JSON.parse(sessionStorage.getItem('userData')).userRole,
          RegionId: JSON.parse(sessionStorage.getItem('userData')).regionId,
        })
      })
      .then(res => res.json())
      .then(result => {
        setRegionCountData(result);
      })
      .catch(err => {
        if (err) {
          // setDataError(err);
        };
      });
  };

  
  useEffect(() => {
    getRegionWiseCounts();   
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid>
        <div style={{ fontSize: '14px', fontWeight: 'bold', }}>Region Wise Analysis</div>
        <MDBox mb={1.5}>
          <TableContainer component={Paper}>
            <Table id="dvRegionWise" style={{ "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
              <TableRow style={{backgroundColor: 'lightsalmon'}}>
                <TableCell width="10%" align="center" style={{ fontSize: '12px', fontWeight: 'bold', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                  Region
                </TableCell>
                <TableCell width="10%" align="center" style={{ fontSize: '12px', fontWeight: 'bold', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                  Total
                </TableCell>
                <TableCell width="10%" align="center" style={{ fontSize: '12px', fontWeight: 'bold', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                  Document Verified
                </TableCell>
                <TableCell width="10%" align="center" style={{ fontSize: '12px', fontWeight: 'bold', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                  Rejected
                </TableCell>               
                <TableCell width="10%" align="center" style={{ fontSize: '12px', fontWeight: 'bold', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                  Certificate Issued
                </TableCell>
                <TableCell width="10%" align="center" style={{ fontSize: '12px', fontWeight: 'bold', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                  Certificate Pending
                </TableCell>                
              </TableRow>
              <TableBody>
                {regionCountData.map((row) => (
                  <TableRow>
                    <TableCell align="center" style={{ fontSize: '12px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                      {row.region}
                    </TableCell>
                    <TableCell align="right" style={{ fontSize: '12px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                      {row.total}
                    </TableCell>
                    <TableCell align="right" style={{ fontSize: '12px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                      {row.approved}
                    </TableCell>
                    <TableCell align="right" style={{ fontSize: '12px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                      {row.rejected}
                    </TableCell>                   
                    <TableCell align="right" style={{ fontSize: '12px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                      {row.certificateIssued}
                    </TableCell>
                    <TableCell align="right" style={{ fontSize: '12px', "borderWidth": "1px", 'borderColor': "#aaaaaa", 'borderStyle': 'solid' }}>
                      {row.certificateDue}
                    </TableCell>                   
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Table>
            <TableRow>
              <TableCell align="center">
                <ReactHTMLTableToExcel table="dvRegionWise" className="info"
                  filename="RegionWiseAnalysis" sheet="Sheet" buttonText="EXPORT TO EXCEL"
                />
              </TableCell>
            </TableRow>
          </Table>
        </MDBox>
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}

export default Analytics;
